import { TileWMS, TileImage, OSM, Stamen, TileDebug, ImageWMS } from 'ol/source';
import { Image as ImageLayer, Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { geoserver_url } from './constant';

export const workspace = "newfantasy";
export const wmsworkspace = "newfantasy";
const url = geoserver_url + "/geoserver/wms";
export const wmsurl = geoserver_url + "/geoserver/wms";
const TRANSPARENTs = false;
const preload = 'infinity';
export const layerlist = [
  // {label:'Fog Layer',checked:true,name:'foglayer',"opacity":1,'toggle':false,visible:false},
  { label: 'Boundary', checked: true, name: 'border', radius: 5, "opacity": 0.8, "servicename": 'getstatedata', "style": 'stateStyle', visible: true, 'toggle': false },
  { label: 'State', checked: true, name: 'state', radius: 5, "opacity": 0.8, "servicename": 'getstatedata', "style": 'stateStyle', visible: true, 'toggle': true },
  { label: 'Terran', checked: true, name: 'terrain_view', radius: 5, "opacity": 1, visible: true, 'toggle': false },
  { label: 'Province', checked: false, name: 'provinces', radius: 5, "opacity": 1, "servicename": 'getprovincedata', "style": 'boundaryStyle', visible: false, 'toggle': true },
  { label: 'Culture', checked: false, name: 'culture', radius: 3, "opacity": 1, "servicename": 'getprovincedata', "style": 'boundaryStyle', visible: false, 'toggle': true },
  { label: 'Religion', checked: false, name: 'religions', radius: 3, "opacity": 1, "servicename": 'getprovincedata', "style": 'boundaryStyle', visible: false, 'toggle': true },
  { label: 'Biome', checked: false, name: 'biomes', radius: 3, "opacity": 1, "servicename": 'getprovincedata', "style": 'boundaryStyle', visible: false, 'toggle': true },
  { label: 'Height', checked: false, name: 'heightmap', radius: 3, "opacity": 1, "servicename": 'getprovincedata', "style": 'boundaryStyle', visible: false, 'toggle': true },
  { label: 'Cells', checked: true, name: 'cells', radius: 5, "opacity": 1, "servicename": 'getstatedata', "style": 'stateStyle', visible: true, 'toggle': false },
  { label: 'Zones', checked: false, name: 'zones', radius: 5, "opacity": 1, "servicename": 'getstatedata', "style": 'stateStyle', visible: false, 'toggle': true },
  { label: 'River', checked: true, name: 'rivers', radius: 3, "opacity": 1, "servicename": 'getriverdata', "style": 'statestyle', visible: true, 'toggle': false },
  { label: 'Route', checked: true, name: 'routes', radius: 5, "opacity": 1, "servicename": 'getroutedata', "style": 'routeStyle', visible: true, 'toggle': false },
  { label: 'Labels', checked: true, name: 'burgs', radius: 5, "opacity": 1, "servicename": 'getburgsdata', "style": 'statestyle', visible: true, 'toggle': false },
  { label: 'Military', checked: false, name: 'military', radius: 3, "opacity": 1, "servicename": 'getprovincedata', "style": 'boundaryStyle', visible: false, 'toggle': false },
  { label: 'Grid', checked: false, name: 'grid', radius: 0, "opacity": 1, "servicename": 'getstatedata', "style": 'statestyle', visible: true, 'toggle': false }];
/* export const layerlist = [
   {label:'State Boundary',checked:true, name:'stateboundary',radius:0,"opacity":0.8, "servicename":'getstatedata',"style":'stateStyle'},
   {label:'Borders',checked:true, name:'borders',radius:0, "opacity":1,"servicename":'getprovincedata',"style":'boundaryStyle'},
   {label:'River',checked:true, name:'river',radius:0,"opacity":1, "servicename":'getriverdata',"style":'statestyle'},
   {label:'Route',checked:true, name:'route',radius:0,"opacity":1, "servicename":'getroutedata',"style":'routeStyle'},
   {label:'Labels',checked:true, name:'burgs',radius:0,"opacity":1, "servicename":'getburgsdata',"style":'statestyle'},
   {label:'Grid',checked:false, name:'grid',radius:0,"opacity":1, "servicename":'getstatedata',"style":'statestyle'}  ];
*/


export const background = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':state', TRANSPARENT: false, BGCOLOR: '0x6b8bbc' },
    ratio: 1, serverType: 'geoserver',
  })
});
export const foglayer = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':foglayer' },
    ratio: 1, serverType: 'geoserver',
  })
});
export const grid = new ImageLayer({
  visible: false,
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':grid' },
    ratio: 1, serverType: 'geoserver'
  })
})
export const stateboundary = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':stateboundary' },
    ratio: 1, serverType: 'geoserver'
  })
});
export const borders = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':borders' },
    ratio: 1, serverType: 'geoserver'
  })
});
export const river = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':rivers' },
    ratio: 1, serverType: 'geoserver'
  })
});
export const route = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':routes' },
    ratio: 1, serverType: 'geoserver'
  })
});
export const burgs = new ImageLayer({
  source: new ImageWMS({
    url: url,
    params: { 'LAYERS': wmsworkspace + ':burgs' },
    ratio: 1, serverType: 'geoserver'
  })
});


export const mapstyle = (feature, type) => {
  var style: any = [
    new Style({
      stroke: new Stroke({
        color: 'blue',
        width: 3,
      }),
      fill: new Fill({
        color: 'rgba(0, 0, 255, 0.1)',
      }),
    }),
    new Style({
      image: new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: 'orange',
        }),
      })
    }),
  ]

  switch (type) {
    case 'stateStyle':
      return stateStyle(feature)
    case 'boundaryStyle':
      return boundaryStyle(feature)
    case 'routeStyle':
      return routeStyle(feature)
    default:
      return style
  }

}


/***
 * Style Functions
 */
const stateStyle = (feature) => {
  const prop: any = feature.getProperties()
  return new Style({
    fill: new Fill({
      color: prop.color,
    }),
  })
}

const boundaryStyle = (feature) => {
  return new Style({
    stroke: new Stroke({
      color: 'rgba(0, 0, 0, 0.5)',
      width: 5,
      lineDash: [10, 10]
    }),
  })
}

const routeStyle = (feature) => {
  return new Style({
    stroke: new Stroke({
      color: '#d3723a',
      width: 5,
      lineDash: [10, 10]
    }),
  })
}